import moment from "moment";
import { truncateFloat } from "./generalHelper";
import { createAdminName } from "./userHelpers";

export const getDetailAreaInformation = ({ project, index, year }) => {

    const { detail, teamAdmin, percentage, name, timeAreas, calculatedHours, difference, startedDate, totalTime, status } = project;
    const { size, extraResources = [], categories } = detail;
    const { finished = "" } = detail.dates;
    const peopleInCharge = teamAdmin.peopleInCharge.map((person) => createAdminName(person.name)).join("/");
    const leaders = teamAdmin.leaders.map((person) => createAdminName(person.name)).join("/");
    const peopleInChargeProject = teamAdmin.peopleInChargeProject.map((person) => createAdminName(person.name)).join("/");
    const { totalGeneral: modeling = 0 } = timeAreas?.modeling || 0
    const { totalGeneral: unity = 0 } = timeAreas?.unity || 0
    const { totalGeneral: web = 0 } = timeAreas?.web || 0
    const { totalGeneral: design = 0 } = timeAreas?.design || 0
    const { totalGeneral: planning = 0 } = timeAreas?.planning || 0;
    const categoryNames = categories.map((category) => category.name).join("/");

    let assetTime = 0;
    let providerTime = 0;
    let serverTime = 0;
    (Array.isArray(extraResources) ? extraResources : [extraResources])
        .forEach((item) => {
            if (item.type === "ASSETS") assetTime += item.hours;
            if (item.type === "PROVEDOR") providerTime += item.hours;
            if (item.type === "SERVIDOR") serverTime += item.hours;
        });
    return {
        key: index + 1,
        finished,
        year: year || "Sin dato",
        peopleInCharge: peopleInCharge || "Sin dato",
        leaders: leaders || "Sin dato",
        peopleInChargeProject: peopleInChargeProject || "Sin dato",
        size: size || "Sin dato",
        percentage: percentage || "Sin dato",
        name: name || "Sin dato",
        status: status || "Sin dato",
        art3d: truncateFloat(modeling),
        unity: truncateFloat(unity),
        web: truncateFloat(web),
        design: truncateFloat(design),
        planning: truncateFloat(planning),
        calculatedPlanning: calculatedHours.planning || "Sin dato",
        totalDevelopment: calculatedHours.development.total || "Sin dato",
        assetTime: truncateFloat(assetTime),
        providerTime: truncateFloat(providerTime),
        serverTime: truncateFloat(serverTime),
        categoryNames: categoryNames,
        differenceTime: truncateFloat(difference),
        startedDate: moment(startedDate).format("DD/MM/YYYY"),
        workingHours: truncateFloat(totalTime)
    };
}
